export default __webpack_public_path__ + "static/media/inactive.d1c756e6.svg";